export class FileResource {
 
}
